import React, { useMemo } from 'react';
import Emoji from './Emoji';
import MessageTooltip from '../../MessageTooltip';

interface ChatRenderEmojiProps {
  message: {
    text: string;
    createdAt: number;
  };
  tooltip?: boolean;
}

const ChatRenderEmoji = function ({
  message: { text, createdAt },
  tooltip = true,
}: ChatRenderEmojiProps) {
  const textMessage = useMemo(() => (
    <div>
      <Emoji>{text}</Emoji>
    </div>
  ), [text]);

  if (!tooltip) {
    return textMessage;
  }

  return (
    <MessageTooltip message={{ createdAt }}>
      {textMessage}
    </MessageTooltip>
  );
};

export default ChatRenderEmoji;
